<template>
		<label class="checkbox">
		  <input type="checkbox"/>
		  <span class="overlay">
		    <svg 
		         xmlns="http://www.w3.org/2000/svg"
		         width="24"
		         height="24"
		         viewBox="0 0 24 24"
		         fill="none"
		         stroke="currentColor"
		         stroke-width="2"
		         stroke-linecap="round"
		         stroke-linejoin="round"
		         stroke-dasharray="24"
		         stroke-dashoffset="-24"
		         class="icon">
		      <polyline points="20 6 9 17 4 12"/>
		    </svg>
		  </span>
		</label>
</template>



<script>

export default {
  name: "base-checkbox",
}


</script>



<style>
.checkbox input {
  position: absolute;
  opacity: 0;
}

.checkbox .overlay {
  position: absolute;
  top: 0px;
  left: 0px;
  height: 24px;
  width: 24px;
  background-color: #F39C12;
  border-radius: 8px;
  border: 2px solid #F39C12;
}

.checkbox .overlay .icon {
  color: white;
}

.checkbox .overlay.checked {
  border-radius: 8px;
  opacity: 1;
  border: 2px solid #F39C12;
}
</style>
